import modalFormMixin from './modal-form.mixin';
import apiConsumerMixin from './api-consumer.mixin';
import { ESTADOS_PROGRAMAS_UNIVERSIDADES, ESTADOS_SOLICITUDES_INSCRIPCIONES } from '../utils/constantes';
import InstitucionService from '../services/institucion.service';
import ProgramaUniversidadService from '../services/programa-universidad.service';

export default {
  mixins: [modalFormMixin, apiConsumerMixin],
  watch: {
    programaUniversidadId: function () {
      this.errores.programaUniversidadId = [];
    },
  },
  data() {
    return {
      visible: false,
      estadosSolicitudesInscripciones: ESTADOS_SOLICITUDES_INSCRIPCIONES,
      item: this.generarObjetoFormRegistrar(),
      errores: [],
      enviando: false,
      universidadId: null,
      universidades: [],
      programaUniversidadId: null,
      programasUniversidades: [],
      estadosProgramasUniversidades: ESTADOS_PROGRAMAS_UNIVERSIDADES,
    };
  },
  methods: {
    cerrar() {
      this.visible = false;
    },
    obtenerUniversidades() {
      this.obtenerDatosMixin(InstitucionService.findAll, 'universidades', {}, () => {
        this.universidades = [];
      });
    },
    async obtenerProgramasUniversidades() {
      const params = {
        universidadId: this.universidadId,
        busqueda: this.busqueda || null,
      };

      this.programasUniversidades = [];

      try {
        const { data } = await ProgramaUniversidadService.findAllPorUniversidadIdBusqueda({ params });

        this.programasUniversidades = data?.datos || [];
      } catch (error) {
        const { mensaje } = error?.response?.data;

        window.console.log(error);

        this.programasUniversidades = [];
        this.$notify({
          group: 'notifications',
          title: 'Error',
          text: mensaje || 'Error al listar',
          type: 'error',
        });
      }
    },
    busquedaProgramaUniversidad(search, loading) {
      if (!search.length) {
        return;
      }

      clearTimeout(this.retardo);

      this.busqueda = search;

      this.retardo = setTimeout(() => {
        loading(true);
        this.obtenerProgramasUniversidades().finally(() => loading(false));
      }, 500);
    },
  },
};
